export default __webpack_public_path__ + "static/kontakt-fde89717ab946952a5730f4982056ee0.svg";